export default __webpack_public_path__ + "static/media/mini_ic_detail.d48909d8.svg";